
import React from 'react';
import { Link } from 'react-router-dom';
import { SectionContainer } from './section/SectionContainer';
import { Facebook, School } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#f9fafb] border-t border-gray-200">
      <SectionContainer containerWidth="wide" className="py-10 md:py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8">
          {/* Logo and Description */}
          <div className="col-span-2">
            <Link to="/" className="flex items-center mb-4">
              <img src="/lovable-uploads/35a616d1-b039-454a-957c-5a01e892bffc.png" alt="AskSpot" className="h-8 w-auto" />
            </Link>
            <p className="text-gray-600 text-sm mb-4 max-w-xs">
              Build AI tools in minutes with no coding required. Empower your business with intelligent, 24/7 customer support.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/askspotai" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#003a70]">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="https://www.linkedin.com/company/askspot" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#003a70]">
                <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="https://skool.com/askspot" target="_blank" rel="noopener noreferrer" className="text-gray-500 hover:text-[#003a70]">
                <School className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Products */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Products</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/features" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/wall-of-love" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Wall of Love
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Privacy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Terms
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold text-gray-900 mb-4">Resources</h3>
            <ul className="space-y-3">
              <li>
                <a href="mailto:support@askspot.ai" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Support
                </a>
              </li>
              <li>
                <a href="https://app.askspot.ai" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Login
                </a>
              </li>
              <li>
                <a href="https://skool.com/askspot" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-[#003a70] text-sm">
                  Skool Community
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-gray-500 text-sm text-center md:text-left">
            &copy; {new Date().getFullYear()} AskSpot. All rights reserved.
          </p>
        </div>
      </SectionContainer>
    </footer>
  );
};

export default Footer;
